// extracted by mini-css-extract-plugin
export var phone = "_1j-0";
export var phoneDragging = "_1j-1";